export const SLICE_NAME = "HISTORICAL_MEANS";